export default __webpack_public_path__ + "static/media/icon-star.2d8e7b7c.svg";